import { JsonProperty } from "../../../models/utilities/json-property";

/** One group of a dealer's pickups, or of the deliveries to an address */
export class OrderGroupChoice {

    public dealerId: string = '';

    /** The address of a group of deliveries, left out for a dealer's pickups */
    public shipToAddressId: number | undefined = undefined;

    public groupId: number = 0;
}

export class CreateProductionRunPickup {

    /** What the run is made from; the same address creates a run from a shipment, so the body says which */
    public readonly source: string = 'orders';

    public name: string = '';

    @JsonProperty({ toType: 'date' })
    public maxCutoff: Date | undefined = undefined;

    /** The dealers whose pickups are in the run */
    public dealerIds: string[] = [];

    /** The ship to addresses whose deliveries are in the run */
    public shipToAddressIds: number[] = [];

    /** The groups of those dealers and addresses that are in the run, when their orders were split into groups */
    public groups: OrderGroupChoice[] = [];

    public isUrgent: boolean = false;

    public division: string | undefined = undefined;

    public shipmentMethod: string | undefined = undefined;
}
